module.exports = __webpack_public_path__ + "media/images/flags/32/Palestine-86b17b7e3498f7f31063743a2f102129.png";